import { useEffect, useState } from 'react'

/**
 * This hook is used to get the height of a container element
 * based on a CSS selector. It uses the ResizeObserver API to
 * observe changes in the height of the container
 * and updates the height state accordingly.
 * It initializes the height with a default value
 * and returns the current height of the container.
 * @param selector
 * @param defaultHeight
 * @returns number
 */
export const useContainerHeight = (selector: string, defaultHeight: number) => {
    const [height, setHeight] = useState<number>(defaultHeight)

    useEffect(() => {
        const htmlElement = document.querySelector(
            selector
        ) as HTMLElement | null
        if (!htmlElement) return

        const updateHeight = () => setHeight(htmlElement.offsetHeight)

        const observer = new window.ResizeObserver(updateHeight)
        observer.observe(htmlElement)
        updateHeight() // Set initial height

        return () => observer.disconnect()
    }, [selector])

    return height
}
